import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedDirectivesModule } from '@ot/shared/directives';
import { SidePanelComponent } from './side-panel.component';

@NgModule({
  declarations: [SidePanelComponent],
  imports: [CommonModule, SharedDirectivesModule],
  exports: [SidePanelComponent]
})
export class SidePanelModule {}
